import React from "react";
import { Link, useNavigate } from "react-router-dom";
import brandLogo from '../../template/images/LHubHeader.png'
import showAlert from "../alert/Alert";
import './layout.css';

const Header = () => {
    const navigate = useNavigate();
const redirectToLogin = () => {
    window.open(`${process.env.REACT_APP_BENEFICIARY_BASE_URL}beneficiary-app`, '_blank');
}

const redirectToCourse = () => {
    showAlert(' ','Please choose a course before proceeding to sign up.', ' ', 'Continue', false, false, redirectTo, false, '', '');
}

const redirectTo = (value) => {
   navigate('/')
}

    return (
        <React.Fragment>
            <header className="header">
                <div className="container">
                    <div className="top_bar">
                        <div className="brand_logo">
                           <Link to="/"> <img src={brandLogo} className="brand_logo_img" alt="Brand Logo"></img></Link>
                        </div>
                        <div className="login_signup">
                            <div className="login_signup_btn_area">
                                <button className="login_btn" onClick={()=>redirectToLogin()}>Login</button>
                                {/* <Link to="/createAccount"> */}
                                <button className="signup_btn" onClick={()=>redirectToCourse()}>Sign Up</button>
                                {/* </Link> */}
                               
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

export default Header;